import { useContext } from 'react';

import dayjs from 'dayjs';

import { UserContext } from 'Context/user';
import { VehicleLookupContext } from 'Context/vehicleLookup';
import { VehicleContext } from 'Context/vehicles';

import { RETURNING_USER_LIMIT } from '../../containers/app/vehicleProfiling/VehicleProfiling.constants';
import { isNotReturningUserApplicable } from '../restricted';

export const useReturningUser = () => {
  const { userState } = useContext(UserContext);
  const { vehicleState: vehicles } = useContext(VehicleContext);
  const { vehicleLookupState: vehicleLookup } = useContext(VehicleLookupContext);

  const noVehicleToReturnTo = [
    !userState?.id,
    !vehicleLookup?.enquiry?.dpEnquiryId,
    !vehicleLookup?.enquiry?.valuation?.estimate,
    (vehicles.length === 0),
    isNotReturningUserApplicable(vehicleLookup?.enquiry?.dpStateSlug),
  ].some((v) => v);

  if (noVehicleToReturnTo) {
    return false;
  }

  const enquiryCreatedAt = vehicleLookup?.enquiry?.createdAt;
  return dayjs(enquiryCreatedAt) >= dayjs().subtract(RETURNING_USER_LIMIT, 'd');
};
